import { render, staticRenderFns } from "./btnAnadir.vue?vue&type=template&id=2f4e7abb&"
import script from "./btnAnadir.vue?vue&type=script&lang=js&"
export * from "./btnAnadir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports